import { useCareActions, useIsOnline } from '@shkola/api';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from '../components/ui';
import { GRAD, INK, PAPER, PillIcon, grad, pillClass } from '../design/forms';
import { PaperPlaneTiltIcon } from '../design/icons';
import { FIELD, Private } from './shared';

/** «Поскаржитися» on a chat message: it reaches the psychologist and the director, anonymously. */
export function ReportDialog({
  schoolId,
  messageId,
  quote,
  onClose,
}: {
  schoolId: string;
  messageId: string;
  quote: string;
  onClose: () => void;
}) {
  const { t } = useTranslation();
  const actions = useCareActions();
  const online = useIsOnline();
  const [comment, setComment] = useState('');
  const [sent, setSent] = useState(false);

  const submit = () => {
    actions.open.mutate({
      schoolId,
      kind: 'bullying',
      topic: 'friends',
      body: comment.trim() || t('care.report.defaultBody'),
      clientId: crypto.randomUUID(),
      reportedMessageId: messageId,
    });
    setSent(true);
  };

  return (
    <Modal title={t('care.report.title')} onClose={onClose}>
      {sent ? (
        <p
          className="rounded-[18px] px-4 py-3 text-[15px] leading-6"
          style={{ backgroundImage: grad('mint'), color: GRAD.mint.ink }}
        >
          {online ? t('care.report.sent') : t('care.write.queued')}
        </p>
      ) : (
        <div className="flex flex-col gap-4">
          <blockquote
            className="rounded-[18px] px-4 py-3 text-[15px] leading-[22px]"
            style={{ backgroundColor: PAPER, color: INK }}
          >
            «{quote}»
          </blockquote>
          <Private>{t('care.report.hint')}</Private>
          <textarea
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            rows={3}
            maxLength={1000}
            aria-label={t('care.report.placeholder')}
            placeholder={t('care.report.placeholder')}
            className={`${FIELD} resize-none`}
            style={{ color: INK }}
          />
          <div>
            <button type="button" onClick={submit} className={pillClass('dark')}>
              {t('care.report.send')}
              <PillIcon icon={PaperPlaneTiltIcon} />
            </button>
          </div>
        </div>
      )}
    </Modal>
  );
}
